// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../../types/schema';

import { EstateWaterfall_VizConfigFragment, EstateWaterfall_GraphVizGroupFragment, EstateWaterfall_EstateWaterfallHypotheticalTransferFragment } from '../../../../../../../estateWaterfall/graphql/EstateWaterfall.generated';
import { GraphViz_NodeConfigFragment } from '../../../../../../../graphViz/graphql/GraphVizNodeConfig.fragment.generated';
import { gql } from '@apollo/client';
import { EstateWaterfall_VizConfigFragmentDoc, EstateWaterfall_GraphVizGroupFragmentDoc, EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../../../../../estateWaterfall/graphql/EstateWaterfall.generated';
import { GraphViz_NodeConfigFragmentDoc } from '../../../../../../../graphViz/graphql/GraphVizNodeConfig.fragment.generated';
export type EstateWaterfallDiagramSlide_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, visualizationConfig?: (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateWaterfall_VizConfigFragment
  ) | null, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string, includedClients: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string } | null } | null> | null }, includedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } | null, visualizationGroups: { __typename?: 'GraphVisualizationGroupConnection', edges?: Array<{ __typename?: 'GraphVisualizationGroupEdge', node?: (
        { __typename?: 'GraphVisualizationGroup' }
        & EstateWaterfall_GraphVizGroupFragment
      ) | null } | null> | null }, outgoingExternalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, incomingExternalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, nodeConfigurations: Array<(
    { __typename?: 'EntityGraphNodeConfiguration' }
    & GraphViz_NodeConfigFragment
  )> };

export const Operations = {
  Fragment: {
    EstateWaterfallDiagramSlide_EstateWaterfall: 'EstateWaterfallDiagramSlide_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallDiagramSlide_EstateWaterfallFragmentDoc = gql`
    fragment EstateWaterfallDiagramSlide_EstateWaterfall on EstateWaterfall {
  id
  visualizationConfig {
    ...EstateWaterfall_VizConfig
  }
  filter {
    id
    includedClients {
      edges {
        node {
          id
        }
      }
    }
    includedEntities {
      edges {
        node {
          id
        }
      }
    }
  }
  visualizationGroups {
    edges {
      node {
        ...EstateWaterfall_GraphVizGroup
      }
    }
  }
  outgoingExternalTransfers: hypotheticalTransfers(
    where: {destinationKind: EXTERNAL}
  ) {
    edges {
      node {
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  incomingExternalTransfers: hypotheticalTransfers(where: {sourceKind: EXTERNAL}) {
    edges {
      node {
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  nodeConfigurations {
    ...GraphViz_NodeConfig
  }
}
    ${EstateWaterfall_VizConfigFragmentDoc}
${EstateWaterfall_GraphVizGroupFragmentDoc}
${EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc}
${GraphViz_NodeConfigFragmentDoc}`;